module.exports = __webpack_public_path__ + "media/components/country-flag/static/gt-0cdd8a174e9b19cce8f792cf7d41d9e0.svg";